<template>
  <!-- sb === search-bar -->
  <div>
    <div class="sb-box index_box" :class="isDown ? 'no-bg' : ''" :style="{ background: backgroundColor }" v-if="theme === 0">
      <div class="sb-logo " :class="isDown ? '' : 'index_head'" @click="LinkToMyInfo()">
        <div class="logo_img">
          <div class="new" v-if="talkMsgCount > 0"></div>
          <img :src="user.avatarUrl" v-if="user.avatarUrl" />
          <span class="flag-icon my-flag-icon" v-else-if="user.flagStyle" :class="'flag-icon-' + user.flagStyle"></span>
          <img src="@/assets/img/avatar.png" v-else />
        </div>
        <!-- <div class="fig css_ae css_flag"></div> -->
        <span v-if="user && user.inMember && user.inMember.userRole === 'EXHIBITOR'">{{ user.inMember.companyUsers.linkNameEn || "Sign in" }}</span>
        <span v-else>{{ user.name || user.name || user.nickName || "Sign in" }}</span>
      </div>
      <div class="sb-search2" @click="show">
        <div class="search">
          <i class="icon iconfont icon-search"></i>
          <div :class="search ? '' : 'is_place'"><p>{{ search || placeholder }}</p></div>
          <!-- <input type="search" :placeholder="'Company/Product/Activity'" v-model="search" disabled /> -->
        </div>
      </div>
      <!-- <div class="sb-tool-btn" @click="LinkToExApply()">
        <img v-if="isDown" src="@/assets/img/new/zsrz.png" />
        <img v-else src="@/assets/img/new/enter.png" />
      </div> -->
      <div class="sb-tool-hall box-sha" @click="goCN()" v-if="isOpenLang">
        <img src="@/assets/img/new/cn_qh.png" />
      </div>
    </div>
    <div class="sb-box no-bg" :style="{ background: '' }" v-else>
      <div class="sb-logo" @click="LinkToMyInfo()">
        <div class="logo_img">
          <div class="new" v-if="talkMsgCount > 0"></div>
          <img :src="user.avatarUrl" v-if="user.avatarUrl" />
          <span class="flag-icon my-flag-icon" v-else-if="user.flagStyle" :class="'flag-icon-' + user.flagStyle"></span>
          <img src="@/assets/img/avatar.png" v-else />
        </div>
        <span v-if="user && user.inMember && user.inMember.userRole === 'EXHIBITOR'">{{ user.inMember.companyUsers.linkNameEn || "Sign in" }}</span>
        <span v-else>{{ user.nameEn || user.name || user.nickName || "Sign in" }}</span>
      </div>
      <div class="sb-search2" @click="show">
        <div class="search">
          <i class="icon iconfont icon-search"></i>
          <div :class="search ? '' : 'is_place'"><p>{{ search || placeholder }}</p></div>
          <!-- <input type="search" :placeholder="'Company/Product/Activity'" v-model="search" disabled /> -->
        </div>
      </div>
      <!-- <div class="sb-tool-btn" @click="LinkToExApply()">
        <img src="@/assets/img/new/zsrz.png" />
      </div> -->
      <div class="sb-tool-hall box-sha" @click="goCN()" v-if="isOpenLang">
        <img src="@/assets/img/new/cn_qh.png" />
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters, mapMutations, mapState, mapActions } from "vuex";

// 搜索选项框
export default {
  name: "search-bar2",
  props: {
    placeholder: {
      type: String,
      default: "Company/Product/Activity",
    },
    theme: {
      type: Number,
      default: 0,
    },
    borderColor: {
      type: String,
      default: "rgba(0,0,0,0.1)",
    },
    backgroundColor: {
      type: String,
      default: "rgba(255,255,255,0)",
    },
    isDown: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      search: "",
      Systemconfig: "",
      cacExList:[
        '3bc3ed3d-d84e-40d6-be92-910905ba0576',
        '33ffaaa0-6c0d-4878-b96e-d22573d3b038',
        '68da03a5-8127-43b0-903c-97ccb982c429',
        '5fe797f0-a87e-46a6-ae72-48205eda9086',
        '63af2701-17c3-4fb1-b826-aca9228adcc3'
      ],
    };
  },
  computed: {
    ...mapGetters({
      search2: "getSearch",
      user: "getUserInfo",
      talkMsgCount: "getTalkMsgCount",
      exhibitionId: "getExhibitionId",
      exhibitionConfig: "getExhibitionConfig",
      isWeixin: "getIsWeixin",
    }),
    ...mapState({
      oPicXS: "oPicXS",
    }),
    UnifiedTopic() {
      if (!this.Systemconfig) {
        return false;
      } else {
        return this.Systemconfig.UnifiedTopic;
      }
    },
    bgImg() {
      if (!this.UnifiedTopic) {
        return false;
      } else {
        return this.UnifiedTopic.Path;
      }
    },
    istrue() {
      if (!this.UnifiedTopic) {
        return false;
      } else {
        let end = this.past(this.UnifiedTopic.EndTime);
        let start = this.Start(this.UnifiedTopic.StartTime);
        console.log(end, start);
        return end && start;
      }
    },
    isServer() {
      let ser = false;
      if (this.user && this.user.inMember && this.user.inMember.companyUsers && this.user.inMember.companyUsers.isAppointment) {
        ser = true;
      }
      return ser;
    },
    isRegOk() {
      return this.user && this.user.inMember && this.user.inMember.userRole && this.user.inMember.userRole != "VISITOR" && this.user.inMember.userRole != "Visitor";
    },
    isCac(){
      return this.cacExList.includes(this.exhibitionId);
    },
    userMsgQuery() {
      return `
        query{
          agoraQuery{
            userUnreadNumber(exhibitionId:"${this.exhibitionId}",publisherId:"${this.user.userId}")
          }
        }
      `;
    },
    serviceMsgQuery() {
      return `
        query{
          agoraQuery{
            exhibitorUnreadNumber(exhibitorId:"${this.user.inMember.exhibitorId}",publisherId:"${this.user.inMember.companyUsers.id}")
          }
        }
      `;
    },
    isOpenLang() {
      let b = false;
      if (this.exhibitionConfig && this.exhibitionConfig.feature.enabledSwitchLanguage) {
        b = true;
      }
      // return this.
      return b;
    },
  },
  watch: {
    search2(val) {
      this.search = val;
    },
  },
  async created() {
    await this.$Myapollo.getUserInfo(this);
    await this.$Myapollo.getExhibitionInfo(this, this.exhibitionId, this.user.userId);
    if (this.isRegOk) {
      this.init();
    }
  },
  beforeDestroy() {
    if (this.time) {
      clearInterval(this.time);
      this.time = null;
    }
  },
  methods: {
    ...mapMutations({
      setSearchBy: "setSearchBy",
      setSearch: "setSearch",
      setTalkMsgCount: "setTalkMsgCount",
    }),
    ...mapActions({
      LinkToExApply: "linkTo/LinkToExApply",
      LinkToLogin: "linkTo/LinkToLogin",
      graphqlPost: "en/CNgraphqlPostByZXS",
    }),
    show() {
      let txt = this.search.trim();
      let txt2 = txt.split(":");
      this.$emit("callback", { txt: txt2[0], type: 0 });
      if (txt2[0]) {
        this.setSearchBy("");
      }
      this.setSearch(txt2[0]);
      this.$emit("search");
      this.$Bus.$emit("searchShow");
    },
    buildivinte() {
      this.$toast("暂未开放，敬请期待");
      //展商入驻
    },
    past(date) {
      // 根据结束时间判断banner是否过期
      const curDate = new Date().getTime();
      const endDate = new Date(date).getTime() + 24 * 3600 * 1000;
      return endDate > curDate;
    },
    Start(date) {
      // 根据开始时间判断banner是否已到
      const curDate = new Date().getTime();
      const startDate = new Date(date).getTime();
      return startDate < curDate;
    },
    LinkToHall() {
      this.$toast("暂未开放，敬请期待");
      return;
      let openHall = this.exConfig.BoothMap;
      if (openHall) {
        // 是否开启展位图
        if (this.lang == "zh") {
          this.$router.push({
            path: "/hallHome",
            query: { exhibitionId: this.entranceId },
          });
        } else {
          this.$router.push({
            path: "/hallHome",
            query: { exhibitionId: this.entranceId, lang: this.lang },
          });
        }
      } else {
        this.$dialog.toast({
          mes: this.$t("Default.hallTip"),
          timeout: 1000,
        });
      }
    },
    LinkToMyInfo() {
      if (this.user && this.user.userId) {
        this.$router.push(`/my-center/${this.exhibitionId}`);
      } else {
        this.LinkToLogin();
      }
    },
    init() {
      this.getCount();
      this.time = setInterval(() => {
        this.getCount();
      }, 30000);
    },
    async getCount() {
      let opt = {
        query: this.userMsgQuery,
        variables: {},
      };
      let data = await this.graphqlPost(opt);
      let count = data.data.agoraQuery.userUnreadNumber || 0;
      if (this.isServer) {
        let opt2 = {
          query: this.serviceMsgQuery,
          variables: {},
        };
        let data2 = await this.graphqlPost(opt2);
        // console.log(data2,'data2')
        count += data2.data.agoraQuery.exhibitorUnreadNumber || 0;
      }
      console.log("新洽谈消息数量", count);
      this.setTalkMsgCount(count || 0);
    },
    //去中文 判断环境，浏览器去中文pc端，微信去中文手机端
    goCN() {
      let url = "";
      // console.log(this.isCac,'是否化工展');
      // return 
      if (this.isWeixin){
        if(this.isCac){
          url = `https://m.cacshowonline.com/home/${this.exhibitionId}`;
        }else{
          url = `https://m2.zhanshangxiu.com/home/${this.exhibitionId}`;
        }
      } else {
        if(this.isCac){
          url = `https://cn.cacshowonline.com/home/index/${this.exhibitionId}`;
        }else{  
          url = `https://show.zhanshangxiu.com/home/index/${this.exhibitionId}`;
        }
      }
      window.location.href = url;
    },
  },
};
</script>

<style scoped lang="scss">
@import "@assets/scss/utils.scss";
.sb-box {
  height: 0.93rem;
  display: flex;
  align-items: center;
  // background: url("@assets/img/bg-top.png") no-repeat;
  // background-size: cover;
  flex-shrink: 0;
  position: fixed !important;
  z-index: 100;
  width: 100%;
  left: 0;
  top: 0;
  &.index_box {
    .sb-logo {
      transition: color border 0.3s;
    }
  }
  &::before {
    bottom: -2px;
  }
  &.no-bg {
    background: #fff;
    .sb {
      &-logo {
        color: #000;
      }
      &-search2 {
      }
      &-tool {
      }
    }
  }
  .sb {
    &-logo {
      .logo_img {
        width: 25px;
        height: 25px;
        margin: 0 0.12rem;
        position: relative;
        .new {
          width: 0.16rem;
          height: 0.16rem;
          position: absolute;
          border-radius: 50%;
          right: -0.08rem;
          top: -0.08rem;
          background: #ff5149;
        }
        img,
        span {
          width: 25px;
          height: 25px;
          border-radius: 50%;
          display: block;
          margin: 0;
        }
      }
      width: 1.86rem;
      height: 0.66rem;
      border-radius: 17px;
      text-align: center;
      border: solid 1px rgba(0, 0, 0, 0.1);
      display: flex;
      align-items: center;
      flex-shrink: 0;
      margin: 0 0.24rem 0 0.3rem;
      font-size: 0.22rem;
      color: #fff;
      span {
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
      }
      &.index_head {
        border-color: #fff;
      }
    }
    &-search2 {
      flex: 1;
    }
    &-tool {
      display: flex;
      align-items: center;
      justify-content: space-around;
      &-btn {
        color: #1890ff;
        font-size: 14px;
        padding: 0 2.8% 0 2.8%;
        &:last-child {
          padding: 0 0.3rem 0 0.36rem;
        }
      }
      &-more {
        color: #1890ff;
        .iconfont {
          font-size: 24px;
        }
      }
    }
  }
  .search-input {
    border-radius: 0;
  }
}
.sb-search2 {
  margin-right: 0.3rem;
  width:calc(100% - 5rem) ;
  .search {
    display: flex;
    align-items: center;
    background-color: #f3f3f3;
    border-radius: 16px;
    .icon {
      padding-left: 5px;
      padding-right: 3px;
      line-height: 28px;
      color: #b2b2b2;
      font-size: 20px;
    }
    >div {
      width: 80%;
      height: 100%;
      border: none;
      background-color: #f3f3f3;
      border-radius: 16px;
      padding: 0 5px;
      display: flex;
      align-items: center;
      line-height: inherit;
      overflow: hidden;
      p{
        font-size: 0.28rem;
        white-space: nowrap;
        overflow: hidden;
        text-overflow: ellipsis;
        color: #7d7d7d;
        // &.is_place {
        // }
      }
      
    }
    input {
      display: block;
      width: 80%;
      height: 100%;
      border: none;
      font-size: inherit;
      background-color: #f3f3f3;
      border-radius: 16px;
      padding: 0 5px;
      font-size: 0.24rem;
    }
  }
}
.sb-box2 {
  height: 42px;
  display: flex;
  align-items: center;
  justify-content: flex-end;
  color: #fff;
  padding: 0 8px;
  a {
    flex: 1;
    height: 100%;
  }
  .sb2-l {
    display: flex;
    flex-direction: column;
    i {
      font-size: 20px;
      position: relative;
      top: 2px;
    }
    span {
      font-size: 9px;
      position: relative;
      top: -2px;
    }
  }
  .sb2-r {
    margin-right: 20px;
  }
}
.sb-tool-hall {
  display: flex;
  flex-direction: column;
  color: #1890ff;
  text-align: center;
  margin: 0 0.3rem 0 0;
  &.box-sha {
    img {
      box-shadow: 0 0 10px 0 rgba(0, 0, 0, 0.1);
      border-radius: 50%;
    }
  }
  span {
    font-size: 9px;
    color: #4d4d4d;
    position: relative;
    top: -3px;
  }
  .icon {
    font-size: 24px;
    position: relative;
    top: 2px;
  }
}
.sb-tool-btn {
  display: flex;
}
.sb-tool-btn,
.sb-tool-hall {
  img {
    width: 25px;
    height: 25px;
  }
}
.fig {
  width: 25px;
  height: 25px;
  border-radius: 50%;
  margin: 0 0.29rem 0 0.12rem;
}
</style>
